const addBetMiddleware = (store) => (next) => (action) => {
    if (action.type === 'betCard/addBet') {
        console.log('Processing bet data:', action.payload);

        const isValidBet = validateBet(action.payload);

        if (isValidBet) {
            const processedBet = { ...action.payload }; // Assuming no processing needed

            // Check for existing bet with the same matchId
            const existingBet = store.getState().betCard.bets.find(
                (bet) => bet.matchId === processedBet.matchId
            );

            if (existingBet && store.getState().betCard.type !== "custom") {
                // Existing bet found for non-custom type: Update or remove based on outcome
                if (existingBet.outcome.id !== processedBet.outcome.id) {
                    console.log('Updating existing bet with different outcome for non-custom type');
                    store.dispatch({
                        type: 'betCard/updateBet',
                        payload: { ...existingBet, ...processedBet },
                    });
                } else {
                    console.log('removing new bet with same outcome for non-custom type');
                    store.dispatch({
                        type: 'betCard/removeBet',
                        payload: existingBet,
                    });
                }
            } else {
               
                console.log('Adding new bet');
                store.dispatch({ type: 'betCard/addBetProcessed', payload: processedBet });
                // }
            }
        } else {
            // Handle invalid bet scenario (e.g., dispatch an error action)
            console.error('Invalid bet:', action.payload);
            // dispatch({ type: 'betCard/addBetError', payload: { message: 'Invalid bet data' } }); (Optional)
        }
    }
    next(action);
};

const validateBet = (bet) => {
    // Implement your other validation logic here (e.g., missing fields, invalid stake)

    return true; // Assuming basic validations are handled elsewhere
};

export default addBetMiddleware;